import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import useParentAuthSync from './hooks/useParentAuthSync';

const DEFAULT_PAGE_TITLE = 'Agent运行时';

const syncDocumentTitleWithRoute = () => {
  const matches = router.state.matches;
  const matchedTitle = [...matches]
    .reverse()
    .map(match => {
      const routeHandle = match.route.handle as { title?: string } | undefined;
      return routeHandle?.title;
    })
    .find(Boolean);

  document.title = matchedTitle || DEFAULT_PAGE_TITLE;
};

const App: React.FC = () => {
  useParentAuthSync();
  useEffect(() => {
    // 检查是否需要重定向
    const basePath = import.meta.env.VITE_BASE_PATH || '/';
    const currentPath = window.location.pathname;

    // 如果当前路径是根路径，且配置了非根的基础路径，则重定向
    if (currentPath === '/' && basePath !== '/') {
      window.location.replace(basePath);
      return;
    }

    // 路由标题同步：指定页面走 handle.title，未指定则回退默认标题。
    syncDocumentTitleWithRoute();
    const unsubscribe = router.subscribe(() => {
      syncDocumentTitleWithRoute();
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
};

export default App;
